import { accessRulesApi, machinesApi } from '@/backend'

export default {
  state: {
    accessRules: [],
    machineSerials: [],
  },
  getters: {
    getAccessRules: state => state.accessRules,
    getMachineSerials: state => state.machineSerials,
  },
  mutations: {
    setAccessRules (state, payload) {
      state.accessRules = payload
    },
    setMachineSerials (state, payload) {
      state.machineSerials = payload
    }
  },
  actions: {
    async loadAccessRules ({ commit }) {
      accessRulesApi.getAccessRules(async (error, data) => {
        if (error) {
          console.error(error)
          return
        }
        await commit('setAccessRules', data)
      })
    },
    async loadMachineSerials ({ state, commit }) {
      if (state.machineSerials.length > 0) {
        return
      }
      machinesApi.getMachineSerials(async (error, data) => {
        if (error) {
          console.error(error)
          return
        }
        await commit('setMachineSerials', data)
      })
    },
    async deleteAccessRule ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        accessRulesApi.deleteAccessRule(payload, async (error) => {
          if (error) {
            let errorText = !error.response?.body ? error.response.statusText : error.response.body.message
            console.error(error)
            reject(errorText)
            return
          }
          await dispatch('loadAccessRules')
          resolve()
        })
      })
    },
    async addAccessRuleGroup ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        accessRulesApi.createAccessRule(payload, async (error) => {
          if (error) {
            let errorText = !error.response?.body ? error.response.statusText : error.response.body.message
            console.error(error)
            reject(errorText)
            return
          }
          await dispatch('loadAccessRules')
          resolve()
        })
      })
    },
    async editAccessRule ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        accessRulesApi.updateAccessRule(payload, async (error) => {
          if (error) {
            let errorText = !error.response?.body ? error.response.statusText : error.response.body.message
            console.error(error)
            reject(errorText)
            return
          }
          await dispatch('loadAccessRules')
          resolve()
        })
      })
    }
  }
}